export enum ForecastTab {
  FactorForecast = 'factor-forecast',
  InvestmentForecast = 'investment-forecast',
}

export type EmptyRightPanelView = {
  type: 'Empty';
};
